import {BannerMultiloadCfg, IBannerMultiloadCfgData} from './BannerMultiloadCfg';
import {BannerRefreshPolicyCfg} from './BannerRefreshPolicyCfg';

export interface IBannerCfgData {
    adm?: IBannerMultiloadCfgData;
    bannerTargeting?: Record<string, string | number>;
    /** callbacksEnabled */
    ce?: boolean;
    checkInViewportThreshold?: number;
    /** experiment */
    expr?: string;
    groupId?: string;
    isaMember?: string;
    lang?: string;
    lastApps?: string;
    place?: string;
    siteZone?: string;
    timeouts?: Record<string, number>;
}

export const DEFAULT_VIEWPORT_THRESHOLD = 0.5;

export class BannerCfg {
    bannerTargeting: Record<string, string | number>;
    callbacksEnabled: boolean;
    checkInViewportThreshold = DEFAULT_VIEWPORT_THRESHOLD;
    experiment: string | null;
    groupId: string;
    isaMember: string;
    language: string;
    lastApplications: string;
    multiLoad: BannerMultiloadCfg;
    place: string;
    siteZone: string;
    timeoutCfg: BannerRefreshPolicyCfg;

    constructor(data: IBannerCfgData = {}) {
        this.bannerTargeting = data.bannerTargeting || {};
        this.callbacksEnabled = data.ce || false;
        if (typeof data.checkInViewportThreshold === 'number' && !isNaN(data.checkInViewportThreshold)) {
            this.checkInViewportThreshold = data.checkInViewportThreshold;
        }
        this.experiment = data.expr || null;
        this.groupId = data.groupId || '';
        this.isaMember = data.isaMember || '';
        this.language = data.lang || '';
        this.lastApplications = data.lastApps || '';
        this.multiLoad = new BannerMultiloadCfg(data.adm || {});
        this.place = data.place || '';
        this.siteZone = data.siteZone || '';
        this.timeoutCfg = new BannerRefreshPolicyCfg(data.timeouts || {});
    }
}
